import { type ComplianceIndividualProfileInput } from "~/graphql/supergraphTypes";

export type OnboardingIndividualProfileFields = Pick<
  ComplianceIndividualProfileInput,
  "placeOfBirthCountryId" | "countryOfCitizenshipId" | "sourceOfWealth"
>;

export const buildOnboardingIndividualFields = (values: {
  placeOfBirthCountryId?: string;
  nationalityCountryId?: string;
  sourceOfWealth?: string;
}): OnboardingIndividualProfileFields => ({
  placeOfBirthCountryId: values.placeOfBirthCountryId
    ? Number(values.placeOfBirthCountryId)
    : null,
  countryOfCitizenshipId: values.nationalityCountryId
    ? Number(values.nationalityCountryId)
    : null,
  sourceOfWealth: values.sourceOfWealth || null,
});
